import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Spacer, spaceMixin, Heading } from "@zillow/constellation";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { LOAN_TERM_IN_MONTHS, LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import RefinanceBarGraph from "./RefinanceBarGraph.esm.js";
import { FieldConfig } from "./RefinanceCalculator.utils.esm.js";
import RefinanceFields from "./RefinanceFields.esm.js";
import RefinanceLegend from "./RefinanceLegend.esm.js";
import RefinanceLineGraph from "./RefinanceLineGraph.esm.js";
import SavingsHeader from "./SavingsHeader.esm.js";
const RefinanceCalculator = ({
  defaultValues,
  editorMode,
  blockInterestRate = 5
}) => /* @__PURE__ */ jsx(Box, { as: CalculatorForm, fieldStorageKey: "refinanceFields", editorMode: editorMode ?? isEditor(), defaultValues: {
  [FieldConfig.loanAmount.name]: 2e5,
  [FieldConfig.rate.name]: blockInterestRate ? blockInterestRate + 0.75 : 5,
  [FieldConfig.term.name]: LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year],
  [FieldConfig.originationYear.name]: (/* @__PURE__ */ new Date()).getFullYear() - 6,
  [FieldConfig.newLoanAmount.name]: 195e3,
  [FieldConfig.newTerm.name]: LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year],
  [FieldConfig.newRate.name]: blockInterestRate ?? 4.35,
  [FieldConfig.fees.name]: 1e3,
  [FieldConfig.cashOut.name]: 0,
  [FieldConfig.rollFees.name]: false,
  ...omitUndefined(defaultValues)
}, children: /* @__PURE__ */ jsx(CalculatorLayout, { fields: /* @__PURE__ */ jsx(RefinanceFields, {}), content: /* @__PURE__ */ jsxs(Box, { sx: {
  display: "flex",
  flexDirection: "column"
}, children: [
  /* @__PURE__ */ jsx(Spacer, { marginBottom: "lg", children: /* @__PURE__ */ jsx(SavingsHeader, {}) }),
  " ",
  /* @__PURE__ */ jsxs(Box, { sx: {
    display: "flex",
    flexDirection: "row",
    "@media $lg_lte": {
      flexDirection: "column"
    }
  }, children: [
    /* @__PURE__ */ jsx(RefinanceBarGraph, {}),
    /* @__PURE__ */ jsx(Box, { sx: {
      width: "100%",
      marginBottom: `${spaceMixin("md")}`,
      "@media $lg": {
        marginBottom: 0,
        marginLeft: `${spaceMixin("lg")}`
      }
    }, children: /* @__PURE__ */ jsx(RefinanceLegend, {}) })
  ] }),
  /* @__PURE__ */ jsxs(Box, { sx: {
    width: "100%",
    display: "block",
    "@media $md_lte": {
      display: "none"
    }
  }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "4", className: "zsg-content_collapsed", children: "Total Savings / Break Even" }),
    /* @__PURE__ */ jsx(RefinanceLineGraph, {})
  ] })
] }) }) });
export {
  RefinanceCalculator as default
};
